<template>
  <div
    style="display:grid;grid-template-columns: max-content max-content max-content max-content;align-items: center;"
  >
    <v-btn-toggle mandatory v-model="selected_option" class="ml-4">
      <v-tooltip top color="#e9c46a" open-on-hover open-delay="150">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            to="/marketing-kampanje"
            active-class="secondary white--text"
            v-bind="attrs"
            v-on="on"
          >
            <sabira_icon
              :strokewidth="3"
              :fill="selected_option == 0 ? 'white' : 'grey'"
              icon="marketing"
            />
          </v-btn>
        </template>
        <span>Marketing kampanje</span>
      </v-tooltip>
      <v-tooltip top color="#e9c46a" open-on-hover open-delay="150">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            to="/marketing-troskovi"
            active-class="secondary white--text"
            v-bind="attrs"
            v-on="on"
          >
            <sabira_icon
              :fill="selected_option == 1 ? 'white' : 'grey'"
              icon="expense"
              :strokewidth="3"
            />
          </v-btn>
        </template>
        <span>Marketing troškovi</span>
      </v-tooltip>
      <v-tooltip top color="#e9c46a" open-on-hover open-delay="150">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            to="/marketing-artikli"
            active-class="secondary white--text"
            v-bind="attrs"
            v-on="on"
          >
            <sabira_icon
              :strokewidth="3"
              :fill="selected_option == 2 ? 'white' : 'grey'"
              icon="product"
            />
          </v-btn>
        </template>
        <span>Marketing artikli</span>
      </v-tooltip>
    </v-btn-toggle>
  </div>
</template>
<script>
export default {
  components: {
    sabira_icon: () => import("@/components/sabira_icon"),
  },
  data() {
    return {
      show_status: false,
      selected_option: 0,
    };
  },
};
</script>
<style scoped>
.v-tooltip__content {
  color: black;
  opacity: 1;
}
</style>
